import { RootState } from "../store";

export const selectDropdownData =
  (code: string) => (state: RootState) =>
    state.masterDropdowns.runtimeRefData[code] || { list: [] };
